export default __webpack_public_path__ + "static/media/dapps6.b97bc7ae.jpg";